
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ChecklistGrid extends Serenity.EntityGrid<ChecklistRow, any> {
        protected getColumnsKey() { return ChecklistColumns.columnsKey; }
        protected getDialogType() { return ChecklistDialog; }
        protected getIdProperty() { return ChecklistRow.idProperty; }
        protected getInsertPermission() { return ChecklistRow.insertPermission; }
        protected getLocalTextPrefix() { return ChecklistRow.localTextPrefix; }
        protected getService() { return ChecklistService.baseUrl; }

        constructor(container: JQuery) {
        super(container);

            this.openDialogsAsPanel = true;

        }
    }
}